import PatentContainer from "@/components/business/PatentContainer/PatentContainer";
import { useChangeBackgroundColor } from "@hooks/useChangeBackgroundColor";
import { theme } from "@styles/theme";
import { removeDealTypeDisplayName } from "@utils/returnDealTypeDisplayName/returnDealTypeDisplayName";

const PatentListPage = () => {
  useChangeBackgroundColor(theme.color.neural.gray00);

  removeDealTypeDisplayName();

  return <PatentContainer />;
};

export default PatentListPage;
